import React from 'react';
import { useHistory } from 'react-router-dom';

import lang from '../../lib/language';

import arrowLeft from '../../assets/img/arrow-left.svg';
import { ClickableDiv } from '..';

import styles from './GoBackButton.module.scss';

const GoBackButton = () => {
  const history = useHistory();
  return (
    <div className={styles.backButtonWrapper}>
      <ClickableDiv className={styles.backButton} onClick={() => history.goBack()}>
        <img src={arrowLeft} alt={lang.commonGoBackBtn()} />
        <div className={styles.text}>
          {lang.commonGoBackBtn()}
        </div>
      </ClickableDiv>
    </div>
  );
};
export default GoBackButton;
